import { __assign } from "tslib";
import React from 'react';
import { SvgIcon } from './SvgIcon';
export var createSvgIcon = function (path, displayName, staticProps) {
    function Icon(props) {
        return (React.createElement(SvgIcon, __assign({}, props, staticProps), path));
    }
    Icon.displayName = "".concat(displayName, "Icon");
    return Icon;
};
//# sourceMappingURL=createSvgIcon.js.map